import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.common.white,
		fontSize: theme.typography.body2.fontSize,
		border: `1px solid ${COLORS.BORDER}`,
		boxShadow: theme.shadows[1]
	}
}));
